import React, { useEffect } from 'react';
import { Tooltip } from 'antd'
import { useSelector } from 'react-redux';
import { CustomGridTable } from '../../../blueplanitUtils/CustomGridTable.js';
import { Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { fetcAllStatuWorkHistoryByIdAsync, getAllWorkHistoryByID } from '../../../Slices/orderSlice.jsx';
import { setLoader } from '../../../Slices/loaderSlice.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

export default function RequestWorkHistory(props) {
    const { RequestInfo } = props;

    const dispatch = useDispatch();
    const workHistoryDetails = useSelector((state) => state.orders.workHistoryDetail);
    const statusWorkHistoryDetails = useSelector((state) => state.orders.statusWorkHistoryDetail);

    useEffect(() => {
        if (RequestInfo?.id) {
            dispatch(getAllWorkHistoryByID(RequestInfo?.id))
        }
    }, [dispatch, RequestInfo?.id]);

    const handleSync = async () => {
        dispatch(setLoader(true));
        try {
            await dispatch(getAllWorkHistoryByID(RequestInfo?.id))
        } catch (error) {
            console.error('Error refetching work history:', error);
        } finally {
            dispatch(setLoader(false));
        }
    };

    useEffect(() => {
        if (RequestInfo?.id) {
            const workHistoryObj = {
                emailId: RequestInfo.id,
            };
            dispatch(fetcAllStatuWorkHistoryByIdAsync(workHistoryObj));
        }
    }, [dispatch, RequestInfo?.id]);


    const getDateTime = (timeValue) => {
        if (!timeValue) return '';
        const startDate = new Date(timeValue).toLocaleDateString();
        const startTimeString = new Date(timeValue).toLocaleTimeString(undefined, { hour12: true });
        return `${startDate} ${startTimeString}`;
    };

    const getTotalWorkingHours = (workHistoryDetails) => {
        let diff = 0;
        workHistoryDetails.forEach((row) => {
            diff += parseInt(row?.endTime) - parseInt(row?.startTime);
        });
        return getTimeToString(diff);
    };

    const calculateWorkingHours = (startTime, endTime) => {
        const start = new Date(startTime);
        const end = new Date(endTime);
        return getTimeToString(end - start);
    };

    const getTimeToString = (diff) => {
        const months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
        const days = Math.floor((diff / (1000 * 60 * 60 * 24)) % 30);
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        return [
            months > 0 ? `${months} month${months > 1 ? 's' : ''}` : '',
            days > 0 ? `${days} day${days > 1 ? 's' : ''}` : '',
            hours > 0 ? `${hours} hr${hours > 1 ? 's' : ''}` : '',
            minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : '',
            seconds > 0 ? `${seconds} sec${seconds > 1 ? 's' : ''}` : '',
        ].filter(Boolean).join(' ');
    };

    const assignToUsers = useSelector((state) => state.loginUserInfo.allUsers);

    const getUserName = (userid) => {
        let userName = 'anonymous';
        assignToUsers?.forEach((userdetails) => {
            if (userdetails?.id === userid) {
                userName = userdetails?.firstname + ' ' + userdetails?.lastname;
            }
        });
        return userName;
    };

    const getUserNameFromEmail = (emailid) => {
        let userName = '';
        if (assignToUsers.length > 0) {
            assignToUsers.forEach((userdetails) => {
                if (userdetails?.email === emailid) {
                    userName = userdetails?.firstname + ' ' + userdetails?.lastname;
                }
            });
        }
        if (!userName) {
            userName = emailid ? emailid.split('@')[0] : [];
        }
        return userName;
    };

    const data = [
        {
            key: `initial-${RequestInfo?.id || 'unknown'}-${RequestInfo?.date || Date.now()}`,
            id: RequestInfo?.id,
            date: getDateTime(parseInt(RequestInfo?.date)),
            oldFolder: 'Start',
            newFolder: 'Start',
            userName: RequestInfo?.createdBy
                ? getUserName(RequestInfo?.createdBy)
                : getUserNameFromEmail(RequestInfo?.from),
        },
        ...statusWorkHistoryDetails?.map((row, idx) => ({
            key: row?.id || `status-${row?.userId}-${row?.changeTime}-${idx}`,
            date: getDateTime(parseInt(row.changeTime)),
            oldFolder: row.oldStatus,
            newFolder: row.newStatus,
            userName: getUserName(row.userId),
        })),
    ];

    const workHistoryData = workHistoryDetails?.map((row) => ({
        key: row?.id || `${row?.userId}-${row?.startTime}-${row?.endTime}`,
        id: row.id,
        totalTime: calculateWorkingHours(parseInt(row?.startTime), parseInt(row?.endTime)),
        startTime: getDateTime(parseInt(row?.startTime)),
        endTime: getDateTime(parseInt(row?.endTime)),
        taskDescription: row?.taskType,
        userName: getUserName(row?.userId),
    }));

    const coloumns = [
        { title: 'Date', dataIndex: 'date', align: 'center' },
        { title: 'Old Folder', dataIndex: 'oldFolder', align: 'center' },
        { title: 'New Folder', dataIndex: 'newFolder', align: 'center' },
        { title: 'User Name', dataIndex: 'userName', align: 'center' },
    ];

    const workHistoryColumns = [
        { title: 'Total Time', dataIndex: 'totalTime', render: (text) => <span>{text}</span> },
        { title: 'Start Time', dataIndex: 'startTime', align: 'center' },
        { title: 'End Time', dataIndex: 'endTime', align: 'center' },
        { title: 'Task Description', dataIndex: 'taskDescription', align: 'center' },
        { title: 'User Name', dataIndex: 'userName', align: 'center' },
    ];

    return (
        <>
            <Typography.Text level={5} style={{ margin: 0, padding: '5px', fontWeight: 'bold' }}>
                Request WorkHistory
            </Typography.Text>
            <CustomGridTable
                dataSource={data}
                columns={coloumns}
                Id="request-work-history-table"
                pagination={false}
                rowKey="key"
                bordered
                style={{ width: '100%', margin: '0 auto' }}
                size="small"
            />
            <Typography.Text level={5} style={{ margin: 0, padding: '5px', fontWeight: 'bold' }}>
                Request Time Records ({getTotalWorkingHours(workHistoryDetails)})
                <Tooltip title="Sync Now">
                    <FontAwesomeIcon
                        icon={faSync}
                        style={{
                            fontSize: '16px',
                            color: '#1890ff',
                            cursor: 'pointer',
                            marginLeft: '10px',

                        }}
                        onClick={handleSync}
                    />


                </Tooltip>
            </Typography.Text>
            <CustomGridTable
                dataSource={workHistoryData}
                columns={workHistoryColumns}
                Id="request-time-records-table"
                pagination={false}
                rowKey="key"
                bordered
                style={{ width: '100%', margin: '0 auto' }}
                size="small"
            />
        </>
    );
}
